export interface RewardsRedeem {
    action?: string;
    success?: boolean;
    url?: string;
}

export interface Reward {
    id?: string;
    account?: string;
    account_name?: string;
    api_enabled?: boolean;
    ui_enabled?: boolean;
    current_balance?: number;
    point?: RewardPoint;
    created_date?: Date;
    users_linked?: any[];
    tenant?: string;
}

export interface RewardPoint {
    allocation?: number;
    allocation_type_lookup?: string;
    balance?: number;
}
